export default __webpack_public_path__ + "static/media/rock.61a8428d.svg";